/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CloneDashboardRequest } from '../../models/clone-dashboard-request';
import { DashboardDto } from '../../models/dashboard-dto';

export interface DashboardsDashboardIdClonePost$Json$Params {
  dashboardId: string;
      body?: CloneDashboardRequest
}

export function dashboardsDashboardIdClonePost$Json(http: HttpClient, rootUrl: string, params: DashboardsDashboardIdClonePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsDashboardIdClonePost$Json.PATH, 'post');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardDto>;
    })
  );
}

dashboardsDashboardIdClonePost$Json.PATH = '/dashboards/{dashboardId}/clone';
